<script>
  import formatDate from '@utils/format-date'
  import createDownloadLink from '@utils/create-download-link'
  import { authComputed } from '@store/helpers'

  export default {
    props: {
      type: {
        type: String,
        default: 'download'
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        formatDate,
      }
    },
    computed: {
      ...authComputed,
    },
    methods: {
      formatCurrency(price) {
        const priceRegExp = new RegExp(/^[0-9]*$/);
        if(!priceRegExp.test(price)) {
          return price
        }
        return '$NT ' + price.toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    }
  }
</script>
<template>
  <div :class="$style.listFile">
    <h5 v-if="list.length === 0" class="d-block d-lg-none text-center">暫無資料</h5>
    <template v-if="type === 'download'">
      <div class="d-none d-lg-block">
        <el-table
          :data="list"
          class="isStyleFile"
        >
          <el-table-column v-slot="{ row }" label="檔案類別" width="160">
            {{ row.categoryTitle }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="名稱">
            {{ row.title }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="檔案大小" width="150">
            {{ row.size ? row.size.split("Bytes")[0] || 0 : 0 }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="日期" width="195">
            {{ formatDate(row.publishUp || '') }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="下載" width="235" align="center">
            <BaseFileButton
              active-class="isStylePrimary isSmall isRadius isOutline2 isFull w-100"
              :file-item="row"
            />
          </el-table-column>
        </el-table>
      </div>
      <div class="d-block d-lg-none">

        <div :class="$style.tableBlockList">
          <div
            v-for="item in list"
            class="tableBlockList__item isSTyleFile"
          >
            <div class="row mobileGutter">
              <div class="col-md-8 col-10">
                <div class="text-base"> {{ item.title }} </div>
              </div>
              <div class="col-md-4 col-2 text-right">
                <BaseFileButton
                  active-class="isStylePrimary isSmaller isRadius isOutline2 isFull"
                  is-style-right
                  :file-item="item"
                />
              </div>
            </div>
            <div class="text-sm mt-2">
              {{ item.categoryTitle }} 
              <span class="color-gray-6 ml-3">{{ item.size ? item.size.split("Bytes")[0] || 0 : 0 }}</span>
              <span class="color-gray-6 ml-3">{{ formatDate(item.publishUp || '') }}</span>
            </div>
            <!-- <div class="pl-2">
              <div class="row">
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">名稱</div>
                  {{ item.title }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">類型</div>
                  {{ item.categoryTitle }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">檔案大小</div>
                  {{ item.size.split("Bytes")[0] }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">日期</div>
                    {{ formatDate(item.publishUp || '') }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <BaseFileButton
                    active-class="isStylePrimary isSmaller isRadius isOutline2 isFull"
                    :file-item="item"
                  />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'product'">
      <div class="d-none d-lg-block">
        <el-table
          :data="list"
          class="isStyleFile"
        >
          <el-table-column v-slot="{ row }" label="產品型號" width="365">
            {{ row.title }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="產品說明">
            {{ row.description }}
          </el-table-column>

          <!-- <el-table-column v-slot="{ row }" label="建議售價(未稅)" width="220">
            {{ formatCurrency(row.recommandPrice) }}
          </el-table-column>
          <el-table-column v-if="isDealer" v-slot="{ row }" label="經銷價(未稅)" width="220">
            {{ formatCurrency(row.distributePrice) }}
          </el-table-column> -->
        </el-table>
      </div>
      <div class="d-block d-lg-none">
        <div :class="$style.tableBlockList">
          <div
            v-for="item in list"
            class="tableBlockList__item "
          >
            <div class="pl-2">
              <div class="row">
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">產品型號</div>
                  {{ item.title }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">產品說明</div>
                  {{ item.description }}
                </div>
                <!-- <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">建議售價(未稅)</div>
                  {{ formatCurrency(item.recommandPrice) }}
                </div>
                <div v-if="isDealer" class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">經銷價(未稅)</div>
                  {{ formatCurrency(item.distributePrice) }}
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'BOT'">
      <div class="d-none d-xl-block">
        <el-table
          :data="list"
          class="isStyleFile"
        >
          <el-table-column v-slot="{ row }" label="檔案案號" width="170">
            {{ row.uuid }}
            <!--{{ row.code }}-->
          </el-table-column>

          <el-table-column v-slot="{ row }" label="檔案單位" width="130">
            {{ row.title }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="內容">
            {{ row.description }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="檔案類別" width="130">
            {{ row.categoryTitle }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="檔案日期" width="190">
            {{ formatDate(row.publishUp || '') }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="下載" width="235" align="center">
            <BaseFileButton
              active-class="isStylePrimary isSmall isRadius isOutline2 isFull"
              :file-item="row"
            />
          </el-table-column>

        </el-table>
      </div>
      <div class="d-block d-xl-none">

        <div :class="$style.tableBlockList">
          <div
            v-for="(item, $index ) in list"
            :key="$index"
            class="tableBlockList__item"
          >
            <div class="pl-2">
              <div class="row">
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">檔案案號</div>
                  {{ item.uuid }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">檔案單位</div>
                  {{ item.title }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">內容</div>
                  {{ item.description }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">檔案類別</div>
                  {{ item.categoryTitle }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">日期</div>
                  {{ formatDate(item.publishUp || '') }}
                </div>
                <div class="col-12">
                  <BaseFileButton
                    active-class="isStylePrimary isSmaller isRadius isOutline2 isFull"
                    :file-item="item"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'event'">
      <div class="d-none d-lg-block">
        <el-table
          :data="list"
          class="isStyleFile"
        >
          <el-table-column v-slot="{ row }" label="檔案名稱">
            {{ row.title }}
          </el-table-column>

          <el-table-column v-slot="{ row }" label="下載" width="235" align="center">
            <BaseFileButton
              active-class="isStylePrimary isSmall isRadius isOutline2 isFull"
              :file-item="row"
            />
          </el-table-column>

        </el-table>
      </div>
      <div class="d-block d-lg-none">

        <div :class="$style.tableBlockList">
          <div
            v-for="(item, $index ) in list"
            :key="$index"
            class="tableBlockList__item"
          >
            <div class="row">
              <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">檔案名稱</div>
                  {{ item.title }}
                </div>
                <div class="col-12 mb-3 font-medium">
                  <div class="text-2sm color-gray-6 font-regular">下載</div>
                  <BaseFileButton
                    active-class="isStylePrimary isOutline2 isFull"
                    :file-item="item"
                  />
                </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<style lang="scss" module>
  .listFile {
    margin-bottom: 2.5rem;

    :global {
      .listFile {

      }
    }
    &:global {
      &.isStyleEvent {
        .tableBlockList__item {
          &.isSTyleFile {
            background: #fff;
          }
          
        }
      }
    }
  }

  .tableBlockList {
    :global {
      .tableBlockList {
        &__item {
          line-height: 2;
          background: rgba(#F5F5F5,0.5);
          padding: 1.25rem 1.125rem;
          &:not(:last-child) {
            margin-bottom: 1.8rem;
          }
          &.isSTyleFile {
            border-top: 1px solid $color-gray-2;
            background: transparent;
          }
        }

        &__title {
          padding: 0.5rem;
          margin-bottom: 1rem;
          color: #FFF;
          background: $color-gray-4;
        }
      }
    }
  }
</style>
